import { SuspensePayment } from './typing';

/**
 * 挂起等待的支付订单
 */
export const SUSPENSE_PAYMENT_SESSION_STORAGE_KEY = 'SUSPENSE_PAYMENTS';

export function getStoragePayments(): SuspensePayment[] {
  const rawValue = sessionStorage.getItem(SUSPENSE_PAYMENT_SESSION_STORAGE_KEY);
  if (!rawValue) {
    return [];
  }
  try {
    return JSON.parse(rawValue);
  } catch (e) {
    return [];
  }
}
export function saveStoragePayments(payments: SuspensePayment[] = []): void {
  const rawValue = JSON.stringify(payments);
  sessionStorage.setItem(SUSPENSE_PAYMENT_SESSION_STORAGE_KEY, rawValue);
}
